import Chevrolet from '../assents/images/cars/pexels-erik-mclean-4517067.jpg'
import Ferrari from '../assents/images/cars/pexels-pavlo-luchkovski-337909.jpg'
import Nissan from '../assents/images/cars/pexels-erik-mclean-4674344.jpg'
import Supra from '../assents/images/cars/pexels-garvin-st-villier-3874330.jpg'

import ChevroletLogo from '../assents/images/carsLogos/pngwing.com (3).png'
import FerrariLogo from '../assents/images/carsLogos/pngegg.png'
import NissanLogo from '../assents/images/carsLogos/pngwing.com (1).png'
import SupraLogo from '../assents/images/carsLogos/pngwing.com.png'

import design from '../assents/icons/slogIcon/icons8-design-100.png'
import community from '../assents/icons/slogIcon/icons8-community-100.png'
import delight from '../assents/icons/slogIcon/icons8-delight-100.png'
import performance from '../assents/icons/slogIcon/icons8-performance-100.png'
import technology from '../assents/icons/slogIcon/icons8-technology-100.png'

import SupraPhoto1 from '../assents/images/Supra/1232815.jpg'
import SupraPhoto2 from '../assents/images/Supra/1232818.jpg'
import SupraPhoto3 from '../assents/images/Supra/1232820.jpg'
import SupraPhoto4 from '../assents/images/Supra/1232821.jpg'
import SupraPhoto5 from '../assents/images/Supra/1232823.jpg'
import SupraPhoto6 from '../assents/images/Supra/1232822.jpg'

import ferrari_488Photo1 from '../assents/images/ferrari_488/906851.jpg'
import ferrari_488Photo2 from '../assents/images/ferrari_488/906852.jpg'
import ferrari_488Photo3 from '../assents/images/ferrari_488/906853.jpg'
import ferrari_488Photo4 from '../assents/images/ferrari_488/906854.jpg'
import ferrari_488Photo5 from '../assents/images/ferrari_488/906855 (1).jpg'

import Nissan_370ZPhoto1 from '../assents/images/Nissan_370Z/359881.jpg'
import Nissan_370ZPhoto2 from '../assents/images/Nissan_370Z/360968.jpg'
import Nissan_370ZPhoto3 from '../assents/images/Nissan_370Z/444412.jpg'
import Nissan_370ZPhoto4 from '../assents/images/Nissan_370Z/446045.jpg'
import Nissan_370ZPhoto5 from '../assents/images/Nissan_370Z/446047.jpg'
import Nissan_370ZPhoto6 from '../assents/images/Nissan_370Z/450387.jpg'

import Chevrolet_Camaro_Z28Photo1 from '../assents/images/Chevrolet_Camaro_Z28/505195.jpg'
import Chevrolet_Camaro_Z28Photo2 from '../assents/images/Chevrolet_Camaro_Z28/505196.jpg'
import Chevrolet_Camaro_Z28Photo3 from '../assents/images/Chevrolet_Camaro_Z28/505197.jpg'
import Chevrolet_Camaro_Z28Photo4 from '../assents/images/Chevrolet_Camaro_Z28/506003.jpg'
import Chevrolet_Camaro_Z28Photo5 from '../assents/images/Chevrolet_Camaro_Z28/506004.jpg'
import Chevrolet_Camaro_Z28Photo6 from '../assents/images/Chevrolet_Camaro_Z28/506005.jpg'

import Porsche_911Photo1 from '../assents/images/Porsche_911/1016571.jpg'
import Porsche_911Photo2 from '../assents/images/Porsche_911/1232801.jpg'
import Porsche_911Photo3 from '../assents/images/Porsche_911/1232809.jpg'
import Porsche_911Photo4 from '../assents/images/Porsche_911/1232811.jpg'
import Porsche_911Photo5 from '../assents/images/Porsche_911/1232812.jpg'
import Porsche_911Photo6 from '../assents/images/Porsche_911/457904.jpg'

import compressor from '../assents/images/accessories/compressor-840706_1920.jpg'
import seat from '../assents/images/accessories/seat-cushion-1099617_1920.jpg'
import wheel from '../assents/images/accessories/wheel-6390292_1920.jpg'

import address from '../assents/icons/icons8-location-100.png'
import phone from '../assents/icons/icons8-phone-100.png'
import email from '../assents/icons/icons8-email-100.png'

const navLinks = [
    {
        "headTitle": "Home",
        "haveSubitems": false,
        "herf": "/home",
    },
    {
        "headTitle": "Inventory",
        "haveSubitems": true,
        "items": [
            {
                "item": "Stander Inventory",
                "herf": "/inventory/stander",
            },
            {
                "item": "Modern Inventory",
                "herf": "/inventory/modern",
            },
            {
                "item": "Sold Inventory",
                "herf": "/inventory/sold",
            },
            {
                "item": "Single Inventory Page",
                "herf": "/inventory/single",
            },
        ],
        "herf": "/inventory",
    },
    {
        "headTitle": "Pages",
        "haveSubitems": true,
        "items": [
            {
                "item": "Auto Loan Calculator",
                "herf": "/pages/calculator",
            },
            {
                "item": "Services",
                "herf": "/pages/services",
            },
            {
                "item": "About us",
                "herf": "/pages/aboutus",
            },
            {
                "item": "Vehicle Comparison",
                "herf": "/pages/vehicle",
            },
            {
                "item": "sell a car",
                "herf": "/pages/sell/car",
            },
            {
                "item": "FAQ",
                "herf": "/pages/FAQ",
            },
            {
                "item": "Coming soon",
                "herf": "/pages/coming/soon",
            },
        ],
        "herf": "/Pages",
    },
    {
        "headTitle": "Blog",
        "haveSubitems": true,
        "items": [
            {
                "item": "Blog-Grid Full Width",
                "herf": "/blog/grid",
            },
            {
                "item": "List with Right Sidebar",
                "herf": "/blog/list/right",
            },
            {
                "item": "Post with Left Sidebar",
                "herf": "/blog/post/left",
            },
            {
                "item": "post with Right Sidebar",
                "herf": "/blog/post/right",
            },
        ],
        "herf": "/Blog",
    },
    {
        "headTitle": "Shop",
        "haveSubitems": false,
        "herf": "/shop",
    },
    {
        "headTitle": "Contact",
        "haveSubitems": false,
        "herf": "/contact",
    },
]


const sliderImages = 
[
    {
        "image": Ferrari,
        "slug": "Innovative Driving Solutions.",
        "slug2": "Sustainable Mobility for Tomorrow.",
        "options": {
            "name": "Ferrari 488 Pista",
            "carLogo": FerrariLogo,
            "Horsepower": "711 (RPM)",
            "highway": "309.00 / 412.00 (miles)",
            "Engine_Type":"Twin Turbo Premium Unleaded V-8",
            "Torque":"567 (RPM)",
            "Transmission":"Auto-Shift Manual w/OD",
            "Price": "$80,635"
        },
    },
    {
        "image": Supra,
        "slug": "Cutting-Edge Automotive Advancements.",
        "slug2": "",
        "options": {
            "name": "Toyota GR Supra",
            "carLogo": SupraLogo,
            "Horsepower": "255 (RPM)",
            "highway": "342.50 / 424.70 (miles)",
            "Engine_Type":"Intercooled Turbo Premium Unleaded I-4",
            "Torque":"295 (RPM)",
            "Transmission":"Automatic w/OD",
            "Price": "$46,635"
        },
    },
    {
        "image": Nissan,
        "slug": "Next-Level Features for Modern Drivers.",
        "slug2": "Green Technology in Motion.",
        "options": {
            "name": "Nissan 370Z",
            "carLogo": NissanLogo,
            "Horsepower": "332 (RPM)",
            "highway": "323.00 / 494.00 (miles)",
            "Engine_Type":"Premium Unleaded V-6",
            "Torque":"270 (RPM)",
            "Transmission":"Manual w/OD",
            "Price": "$31,015"
        },
    },
    {
        "image": Chevrolet,
        "slug": "Empowering Your Journey with Advanced Features.",
        "slug2": "Driving Excellence Through Innovation.",
        "options": 
        {
            "name": "Chevrolet Camaro Z28",
            "carLogo": ChevroletLogo,
            "Horsepower": "505 (RPM)",
            "highway": "247.00 / 361.00 (miles)",
            "Engine_Type":"Gas V8",
            "Torque":"481 (RPM)",
            "Transmission":"Manual",
            "Price": "$75,000"
        },
    },
]

const advantagesSportCars = [
    {
        "Icon": performance,
        "title":"Performance",
        "paragraph":"Sports vehicles are engineered for high performance, delivering powerful acceleration, sharp handling, and enhanced maneuverability. This provides drivers with a thrilling and dynamic driving experience."
    },
    {
        "Icon": design,
        "title":"Design Aesthetics",
        "paragraph":"Sports vehicles often boast sleek and aerodynamic designs, capturing attention with their visually appealing aesthetics. The stylish and dynamic appearance contributes to their allure."
    },
    {
        "Icon": technology,
        "title":"Technology",
        "paragraph":"Sports vehicles frequently incorporate cutting-edge technology and engineering innovations, showcasing the latest advancements in automotive design. This attracts individuals interested in staying at the forefront of automotive trends."
    },
    {
        "Icon": delight,
        "title":"Driving Enjoyment",
        "paragraph":"Sport vehicles are designed to be fun to drive, emphasizing the joy and satisfaction of being behind the wheel. This focus on driving enjoyment appeals to those who see driving as more than just a means of transportation."
    },
    {
        "Icon": community,
        "title":"Culture",
        "paragraph":"Owning a sports vehicle is often associated with a community of like-minded enthusiasts. This shared passion fosters a sense of camaraderie and community among sports car owners."
    },
]

const CarCardData = [
    {
        "images":[
            SupraPhoto1,
            SupraPhoto2,
            SupraPhoto3,
            SupraPhoto4,
            SupraPhoto5,
            SupraPhoto6,
        ],
        "carName": "Toyota GR Supra",
        "price":"$46,635",
        "options": {
            "Horsepower": "255 (RPM)",
            "highway": "342.50 / 424.70 (miles)",
            "Engine_Type":"Intercooled Turbo Premium Unleaded I-4",
            "Torque":"295 (RPM)",
            "Transmission":"Automatic w/OD",
            "highSpeed": "424",
            "Displacement": "3.0L"
        },
    },
    {
        "images":[
            ferrari_488Photo1,
            ferrari_488Photo2,
            ferrari_488Photo3,
            ferrari_488Photo4,
            ferrari_488Photo5,
        ],
        "carName": "ferrari 488",
        "price":"$80,635",
        "options": {
            "Horsepower": "711 (RPM)",
            "highway": "309.00 / 412.00 (miles)",
            "Engine_Type":"Twin Turbo Premium Unleaded V-8",
            "Torque":"567 (RPM)",
            "Transmission":"Auto-Shift Manual w/OD",
            "highSpeed": "412",
            "Displacement": "3.0L"
        },
    },
    {
        "images":[
            Chevrolet_Camaro_Z28Photo1,
            Chevrolet_Camaro_Z28Photo2,
            Chevrolet_Camaro_Z28Photo3,
            Chevrolet_Camaro_Z28Photo4,
            Chevrolet_Camaro_Z28Photo5,
            Chevrolet_Camaro_Z28Photo6,
        ],
        "carName": "Chevrolet Camaro Z28",
        "price":"$75,000",
        "options": 
        {
            "Horsepower": "505 (RPM)",
            "highway": "247.00 / 361.00 (miles)",
            "Engine_Type":"Gas V8",
            "Torque":"481 (RPM)",
            "Transmission":"Manual",
            "highSpeed": "361",
            "Displacement": "3.0L"
        },
    },
    {
        "images":[
            Nissan_370ZPhoto1,
            Nissan_370ZPhoto2,
            Nissan_370ZPhoto3,
            Nissan_370ZPhoto4,
            Nissan_370ZPhoto5,
            Nissan_370ZPhoto6,
        ],
        "carName": "Nissan 370Z",
        "price":"$31,015",
        "options": {
            "Horsepower": "332 (RPM)",
            "highway": "323.00 / 494.00 (miles)",
            "Engine_Type":"Premium Unleaded V-6",
            "Torque":"270 (RPM)",
            "Transmission":"Manual w/OD",
            "highSpeed": "494",
            "Displacement": "3.0L"
        },
    },
    {
        "images":[
            Porsche_911Photo1,
            Porsche_911Photo2,
            Porsche_911Photo3,
            Porsche_911Photo4,
            Porsche_911Photo5,
            Porsche_911Photo6,
        ],
        "carName": "Porsche 911",
        "price":"$116,050",
        "options": {
            "Horsepower": "379 (RPM)",
            "highway": "304.20 / 405.60 (miles)",
            "Engine_Type":"Twin Turbo Premium Unleaded H-6",
            "Torque":"331 (RPM)",
            "Transmission":"Auto-Shift Manual w/OD",
            "highSpeed": "405",
            "Displacement": "3.0L"
        },
    },
    {
        "images":[
            Porsche_911Photo1,
            Porsche_911Photo2,
            Porsche_911Photo3,
            Porsche_911Photo4,
            Porsche_911Photo5,
            Porsche_911Photo6,
        ],
        "carName": "Porsche 911",
        "price":"$316,500",
        "options": {
            "Horsepower": "379 (RPM)",
            "highway": "304.20 / 405.60 (miles)",
            "Engine_Type":"Twin Turbo Premium Unleaded H-6",
            "Torque":"331 (RPM)",
            "Transmission":"Auto-Shift Manual w/OD",
            "highSpeed": "405",
            "Displacement": "3.0L"
        },
    },
]

const statistics = [
    {
        "title": "CARS SOLD",
        "number": 15514
    },
    {
        "title": "CARS FOR SALE",
        "number": 1201
    },
    {
        "title": "REVIEWS",
        "number": 2150
    },
    {
        "title": "VISITORS PER DAY",
        "number": 3800
    },
]

const carAccessiories = [
    {
        "title":'Compressor, Tire pump',
        "img": compressor,
        "price":'$3,000.00',
        "lastPrice":null
    },
    {
        "title":'Seat cushion',
        "img": seat,
        "price":'$25,750.0',
        "lastPrice":"$30,700.00"
    },
    {
        "title":'Wheel rim',
        "img": wheel,
        "price":'$1,500.00',
        "lastPrice":null
    }
]
const contactData = [
    {
        "title":"Address",
        "icon": address,
        "value":"1010 Avenue of the Moon New York, NY 10018 US."
    },
    {
        "title":"phone",
        "icon": phone,
        "value":"+16851475202"
    },
    {
        "title":"Email",
        "icon": email,
        "value":"example@gmail.com"
    },
]
export {navLinks,sliderImages,advantagesSportCars
    ,CarCardData,statistics,carAccessiories,contactData}